import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

// Redux
import { withFirestore } from '../HOCs';

const firestoreConnect = (arrayOrFunctionOfCollections = []) => {
  return (WrappedComponent) => {
    class FirestoreConnect extends Component {
      constructor(props) {
        super(props);
        this.state = {
          auth: {
            isEmpty: true,
          },
          unsubscriptions: [],
        };
      }

      render() {
        return <WrappedComponent {...this.props} />;
      }

      static getDerivedStateFromProps(nextProps, prevState) {
        if (prevState.auth.isEmpty !== nextProps.auth.isEmpty) {
          return {
            auth: nextProps.auth,
          };
        }
        return null;
      }

      componentDidMount() {
        if (Array.isArray(arrayOrFunctionOfCollections)) {
          if (arrayOrFunctionOfCollections.length > 0) {
            arrayOrFunctionOfCollections.forEach((collectionObject) => {
              this.setState({
                ...this.state,
                unsubscriptions: [
                  ...this.state.unsubscriptions,
                  collectionObject.queryDatabase(
                    this.props.firestore,
                    this.props.dispatch
                  ),
                ],
              });
            });
          }
        } else {
          if (
            !this.state.auth.isEmpty ||
            this.props.merchant ||
            this.props.deliveryServices ||
            this.props.partner
          ) {
            arrayOrFunctionOfCollections(this.props).forEach(
              (collectionObject) => {
                this.setState({
                  ...this.state,
                  unsubscriptions: [
                    ...this.state.unsubscriptions,
                    collectionObject.queryDatabase(
                      this.props.firestore,
                      this.props.dispatch
                    ),
                  ],
                });
              }
            );
          }
        }
      }

      componentDidUpdate(prevProps, prevState) {
        if (
          !Array.isArray(arrayOrFunctionOfCollections) &&
          ((prevState.auth.isEmpty && !this.state.auth.isEmpty) ||
            prevProps.merchant !== this.props.merchant ||
            prevProps.deliveryServices !== this.props.deliveryServices ||
            prevProps.partner !== this.props.partner ||
            prevProps.userWalletId !== this.props.userWalletId ||
            (prevProps.merchants &&
              prevProps.merchants[prevProps.auth.uid] &&
              !prevProps.merchants[prevProps.auth.uid].walletId &&
              this.props.merchants[this.props.auth.uid] &&
              this.props.merchants[this.props.auth.uid].walletId) ||
            (prevProps.delivery &&
              prevProps.delivery[prevProps.auth.uid] &&
              !prevProps.delivery[prevProps.auth.uid].walletId &&
              this.props.delivery[this.props.auth.uid] &&
              this.props.delivery[this.props.auth.uid].walletId) ||
            (prevProps.partners &&
              prevProps.partners[prevProps.auth.uid] &&
              !prevProps.partners[prevProps.auth.uid].walletId &&
              this.props.partners[this.props.auth.uid] &&
              this.props.partners[this.props.auth.uid].walletId))
        ) {
          arrayOrFunctionOfCollections(this.props).forEach(
            (collectionObject) => {
              this.setState({
                ...this.state,
                unsubscriptions: [
                  ...this.state.unsubscriptions,
                  collectionObject.queryDatabase(
                    this.props.firestore,
                    this.props.dispatch
                  ),
                ],
              });
            }
          );
        }
      }

      componentWillUnmount() {
        if (this.state.unsubscriptions.length > 0) {
          this.state.unsubscriptions.forEach((unsubscribe) => unsubscribe());
        }
      }
    }

    const mapStateToProps = ({
      firebase: {
        auth,
        profile: { merchant, deliveryServices, walletId, partners: partner },
      },
      DB: {
        docs: { wallets, merchants, delivery, partners },
      },
    }) => ({
      auth,
      userWalletId: walletId,
      deliveryServices: (deliveryServices && deliveryServices) || null,
      merchant: (merchant && merchant) || null,
      partner: (partner && partner) || null,
      wallets: wallets,
      merchants: (merchants && merchants) || {},
      delivery: (delivery && delivery) || {},
      partners: (partners && partners) || {},
    });

    const enhance = compose(withFirestore, connect(mapStateToProps));

    return enhance(FirestoreConnect);
  };
};

export default firestoreConnect;
